import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

export default function Contact() {
  // Load Fillout Script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://server.fillout.com/embed/v1/";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      const existingScript = document.querySelector(`script[src="${script.src}"]`);
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <section id="contact-section" className="py-24 md:py-32 bg-ivory relative">
      {/* Decorative background element */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none overflow-hidden">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          <path d="M0 100 C 20 0 50 0 100 100" fill="none" stroke="currentColor" className="text-olive" strokeWidth="0.1" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        {/* Header Section */}
        <div className="text-center mb-16 md:mb-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <span className="text-gold uppercase tracking-[0.4em] text-[10px] md:text-xs mb-6 block font-bold">
              Begin Your Journey
            </span>
            <h2 className="text-4xl md:text-6xl mb-8 text-olive font-serif leading-tight">
              Your Summer Wedding <br className="hidden md:block" /> Date May Be Waiting
            </h2>
            <div className="w-20 h-[1px] bg-gold mx-auto mb-8"></div>
            <p className="font-sans font-light text-lg md:text-xl text-olive/70 max-w-3xl mx-auto leading-relaxed">
              Select July and August dates are available for couples ready to tour, plan, and secure a romantic estate wedding at Padua.
            </p>
          </motion.div>
        </div>

        {/* Fillout Form Container - Now much wider and more prominent */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.2 }}
          className="relative max-w-[1100px] mx-auto"
        >
          {/* Main Frame */}
          <div className="bg-white shadow-[0_20px_50px_rgba(58,75,53,0.12)] border border-gold/20 overflow-hidden rounded-sm">
            
            {/* Desktop Padding Wrapper */}
            <div className="w-full min-h-[650px] md:min-h-[750px] p-0 md:p-8 lg:p-12 bg-white">
              <div 
                style={{ width: '100%', height: '700px' }} 
                className="w-full h-[650px] md:h-[700px]"
                data-fillout-id="o8p1rKaJuMus" 
                data-fillout-embed-type="standard" 
                data-fillout-inherit-parameters 
                data-fillout-dynamic-resize
              ></div>
            </div>

            {/* Subtle bottom border accent */}
            <div className="h-1.5 w-full bg-gradient-to-r from-ivory via-gold/40 to-ivory"></div>
          </div>

          {/* Decorative Elements for Desktop */}
          <div className="hidden lg:block absolute -top-6 -left-6 w-24 h-24 border-t border-l border-gold/30 pointer-events-none"></div>
          <div className="hidden lg:block absolute -bottom-6 -right-6 w-24 h-24 border-b border-r border-gold/30 pointer-events-none"></div>
        </motion.div>

        {/* Footer Note */}
        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.6 }}
          className="mt-16 text-center"
        >
          <p className="text-[11px] md:text-xs uppercase tracking-[0.3em] text-olive/50 font-medium">
            Personalized Estate Tours Available Tuesday — Sunday
          </p>
          <div className="mt-6 flex justify-center gap-8 opacity-40">
            <div className="w-1 h-1 bg-olive rounded-full"></div>
            <div className="w-1 h-1 bg-olive rounded-full"></div>
            <div className="w-1 h-1 bg-olive rounded-full"></div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}